<template>
  <validation-observer>
    <b-form slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)">
      <!-- Name -->
      <form-input
        v-model="uomFormData.name"
        :disabled="loading"
        name="Name"
        placeholder="Enter unit of measure name"
        rules="required"
        label="Name"
      />

      <!-- Abbreviation -->
      <form-input
        v-model="uomFormData.abbreviation"
        :disabled="loading"
        name="Abbreviation"
        placeholder="Enter abbreviation (e.g., KG, L, PCS)"
        rules="required"
        label="Abbreviation"
      />

      <!-- Description -->
      <form-text-area
        v-model="uomFormData.description"
        :disabled="loading"
        name="Description"
        placeholder="Enter unit of measure description"
        label="Description"
      />

      <!-- Is Active -->
      <b-form-group label="Status" class="mb-3">
        <b-form-checkbox
          id="uom-active"
          v-model="uomFormData.isActive"
          name="uom-active"
          value="true"
          unchecked-value="false"
          :disabled="loading"
        >
          Active
        </b-form-checkbox>
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-button
          type="button"
          variant="outline-secondary"
          :disabled="loading"
          class="mr-1"
          @click="$emit('cancel')"
        >
          Cancel
        </b-button>
        <b-button type="submit" variant="primary" :disabled="loading">
          <b-spinner small v-if="loading" class="mr-1"></b-spinner>
          {{ loading ? 'Saving...' : 'Save HS Code' }}
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import { BForm, BFormGroup, BFormCheckbox, BButton, BSpinner } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ref, computed, watch } from '@vue/composition-api';
import store from '@/store';
import { FormInput, FormTextArea } from '@/views/apps/fbr-invoice/components/form';

export default {
  name: 'UOMForm',
  components: {
    BForm,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BSpinner,

    // Form Validation
    ValidationObserver,
    ValidationProvider,

    // Custom Components
    FormInput,
    FormTextArea,
  },
  model: {
    prop: 'formData',
    event: 'update:form-data',
  },
  props: {
    formData: {
      type: Object | null,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit', 'update:form-data', 'cancel'],
  setup(props, { emit }) {
    const businessID = computed(() => store.state.user.businessID);

    const uomFormData = ref(
      props.formData
        ? JSON.parse(JSON.stringify(props.formData))
        : {
            id: 0,
            name: '',
            abbreviation: '',
            description: '',
            isActive: true,
            businessID: businessID.value,
          }
    );

    const onSubmit = async () => {
      console.log('Emitting:', JSON.stringify(uomFormData.value, null, 2));
      emit('submit');
    };

    watch(
      uomFormData,
      (newVal) => {
        emit('update:form-data', newVal);
      },
      { deep: true }
    );

    return {
      uomFormData,
      onSubmit,
    };
  },
};
</script>
